<template>
  <!-- CoreUI 3.0.0 に CModalHeader / CModalBody は無い。題名は title（見出しの帯）へ、本文は既定のスロットへ置く。 -->
  <CModal
    title="部署組織図"
    :show="true"
    class="preika-modal-xl"
    :close-on-backdrop="true"
    @update:show="onUpdateShow"
  >
      <div v-if="loading" class="text-center py-4">
        読み込み中...
      </div>

      <div v-else class="table-responsive">
        <table class="table table-bordered org-chart-table mb-0">
          <thead>
            <tr>
              <th style="width: 110px;">階層</th>
              <th>部署（組織ツリー）</th>
            </tr>
          </thead>
          <tbody>
            <tr v-if="flatRows.length === 0">
              <td colspan="2" class="text-center">
                部署データがありません
              </td>
            </tr>

            <tr
              v-for="(node, index) in flatRows"
              :key="'row-' + index + '-' + node.id"
            >
              <th class="text-center align-middle">
                第{{ node.level + 1 }}階層
              </th>
              <td class="align-middle">
                <div
                  class="dept-cell"
                  :style="{ paddingLeft: (node.level * 24) + 'px' }"
                >
                  <div class="dept-node-line">
                    <span v-if="node.level > 0" class="tree-prefix">└ </span>
                    <span class="dept-name">{{ node.name }}</span>
                  </div>

                  <!-- 部署名の下に部署長名を表示 -->
                  <div class="dept-head" v-if="node.head_user_name">
                    {{ node.head_user_name }}
                  </div>
                </div>
              </td>
            </tr>
          </tbody>
        </table>
      </div>

      <div class="small text-muted mt-2">
        ※ 親部署未設定の部署は第1階層（最上段）に表示しています。表示順は「並び優先度 → ID」です。
      </div>

    <template #footer>
      <button type="button" class="btn btn-secondary" @click="$emit('close')">
        閉じる
      </button>
    </template>
  </CModal>
</template>

<script>
export default {
  name: 'OrganizationChartModal',
  props: {
    items: {
      type: Array,
      default: function () {
        return []
      }
    },
    loading: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    flatRows: function () {
      const normalized = (Array.isArray(this.items) ? this.items : [])
        .map((item) => {
          const id = item && item.id != null ? String(item.id) : ''
          const parentId = item && item.parent_id != null && item.parent_id !== ''
            ? String(item.parent_id)
            : ''
          const orderLevelNum = Number(item && item.order_level)

          return {
            id: id,
            parent_id: parentId,
            name: item && item.name ? item.name : '',
            head_user_name: item && item.head_user_name ? item.head_user_name : '',
            order_level: Number.isFinite(orderLevelNum) ? orderLevelNum : 0
          }
        })
        .filter((item) => item.id !== '')

      if (normalized.length === 0) {
        return []
      }

      const nodeMap = {}
      normalized.forEach((item) => {
        nodeMap[item.id] = item
      })

      const childrenMap = {}
      normalized.forEach((item) => {
        const key = item.parent_id
        if (!childrenMap[key]) {
          childrenMap[key] = []
        }
        childrenMap[key].push(item)
      })

      Object.keys(childrenMap).forEach((key) => {
        childrenMap[key].sort(this.sortDepartment)
      })

      // 親部署未設定 or 親が存在しないものを最上位にする
      const roots = normalized
        .filter((item) => item.parent_id === '' || !nodeMap[item.parent_id])
        .sort(this.sortDepartment)

      const result = []
      const visited = {}

      const walk = (node, level) => {
        if (!node || visited[node.id]) return

        visited[node.id] = true
        result.push({
          id: node.id,
          name: node.name,
          head_user_name: node.head_user_name,
          level: level
        })

        const children = childrenMap[node.id] || []
        children.forEach((child) => {
          walk(child, level + 1)
        })
      }

      roots.forEach((root) => {
        walk(root, 0)
      })

      // 循環参照などで取り残しがある場合の保険
      const remains = normalized
        .filter((item) => !visited[item.id])
        .sort(this.sortDepartment)

      remains.forEach((item) => {
        walk(item, 0)
      })

      return result
    }
  },
  methods: {
    onUpdateShow: function (value) {
      if (!value) {
        this.$emit('close')
      }
    },
    sortDepartment: function (a, b) {
      const aOrder = Number(a.order_level)
      const bOrder = Number(b.order_level)
      const av = Number.isFinite(aOrder) ? aOrder : 0
      const bv = Number.isFinite(bOrder) ? bOrder : 0

      if (av !== bv) return av - bv

      const aId = Number(a.id)
      const bId = Number(b.id)
      if (Number.isFinite(aId) && Number.isFinite(bId) && aId !== bId) {
        return aId - bId
      }

      return String(a.id).localeCompare(String(b.id), 'ja')
    }
  }
}
</script>

<style scoped>
.org-chart-table th,
.org-chart-table td {
  vertical-align: top;
}

.dept-cell {
  min-width: 320px;
}

.dept-node-line {
  line-height: 1.3;
}

.tree-prefix {
  color: #6c757d;
}

.dept-name {
  font-weight: 700;
  white-space: nowrap;
}

.dept-head {
  font-size: 14px;
  font-weight: 400;
  white-space: nowrap;
  margin-top: 2px;
  margin-left: 18px; /* └ のぶん少し揃える */
}
</style>
